export function searchResults() {

	const searchQuery = document.getElementById('search-results-query').value;
	const collectionEl = document.getElementById('search-results-collections');
	const productEl = document.getElementById('search-results-products');
	const moneyFormat = document.getElementById('js-money-format').value

	function search(query) {
		
		fetch(`/search/suggest.json?q=${query}&resources[type]=collection,product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)

		.then(response => response.json())
		
		.then(suggestions => {

			if (suggestions.status) {
				console.error(json.status, json.message, json.description);
				return
			}

			const collections = suggestions.resources.results.collections;
			const products = suggestions.resources.results.products;
			
			const collectionSuggestions = collections.map((collection)=> {

				if (!collection.featured_image.url) {
					return ''
				}

				return `<div class="card collection-card">
				<div class="stack stack--s align-center text-center">
					<figure class="frame frame--4x3">
						<img src="${ collection.featured_image.url }" alt="${ collection.featured_image.alt != '' ? collection.featured_image.alt : collection.title }">
					</figure>
					<a href="${ collection.url }" class="card__link">${ collection.title }</a>
				</div>
			</div>`
			})

			const productSuggestions = products.map((product)=> {
				return `
<article class="card product-card text-center flex direction-column justify-between small">

	<div class="stack">
		<figure class="frame frame--1x1">
			<img src="${ product.featured_image.url }" alt="${ product.title }">
		</figure>

		<div class="stack  stack--s align-center box box--s-pad" style="--box-border-color: transparent;">

			<a class="card__link" href="${ product.url }"><h3 class="h h4">${product.title}</h3></a>

		</div>

	</div>
	
	<div class="price">
		<div class="js-price">${ Shopify.formatMoney(product.price, moneyFormat)}</div>
	</div>

</article>`
			})



			return {
				collections: collectionSuggestions.join(''),
				products: productSuggestions.slice(0, 6).join('')
			}

		})
		.then(data => {
			return updateCollections(data);
		});

	}

	function updateCollections(html) {


		collectionEl.innerHTML = html.collections;
		productEl.innerHTML = html.products;

		return
	}

	search(searchQuery);
}